import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import {
  ComplianceProtocolAnswer,
  NumericProtocolAnswer,
  OptionSelectionProtocolAnswer,
  ProtocolAnswer,
  TextProtocolAnswer,
} from 'shared/domain/protocolAnswer/types';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';

export function protocolAnswerInDtoToProtocolAnswer(
  answer: ProtocolAnswerInDto
): ProtocolAnswer {
  const isApplicable = answer.isApplicable ?? true;

  switch (answer.type) {
    case AnswerType.Compliance:
      return {
        _id: answer._id,
        checklistAnswerId: answer.checklistAnswerId,
        type: AnswerType.Compliance,
        isApplicable,
        selectedOption: answer.selectedOption,
      } satisfies ComplianceProtocolAnswer;
    case AnswerType.Numeric:
      return {
        _id: answer._id,
        checklistAnswerId: answer.checklistAnswerId,
        type: AnswerType.Numeric,
        isApplicable,
        numericValue: answer.numericValue,
      } satisfies NumericProtocolAnswer;
    case AnswerType.Text:
      return {
        _id: answer._id,
        checklistAnswerId: answer.checklistAnswerId,
        type: AnswerType.Text,
        isApplicable,
        textValue: answer.textValue,
      } satisfies TextProtocolAnswer;
    case AnswerType.OptionSelection:
      return {
        _id: answer._id,
        checklistAnswerId: answer.checklistAnswerId,
        type: AnswerType.OptionSelection,
        isApplicable,
        selectedOptionIds: answer.selectedOptionIds,
      } satisfies OptionSelectionProtocolAnswer;
  }
}
